/**
 * Add to Cart and Open Cart Action
 * Triggered by: arc:action:addToCartAndCartOpen
 */

export const runAddToCartAndCartOpen = async (data = {}) => {
  if (window.enableDebugMode) { console.log('runAddToCartAndCartOpen called with data:', data); }
  
  try {
    // extraItems: ticked Complete the Set rows, added in the same request as the main item
    let { variantId, quantity = 1, properties = {}, extraItems = [] } = data;

    if (!variantId) {
      throw new Error('Variant ID is required and could not be determined from product context');
    }

    // Dispatch loading start event
    window.dispatchEvent(new CustomEvent('cart:add_loading_start', { detail: { variantId, quantity } }));

    // Use Alpine cart store
    await Alpine.store('cart').addItems([{ id: variantId, quantity, properties }, ...extraItems]);

    // Dispatch success events
    window.dispatchEvent(new CustomEvent('cart:item_added', { detail: { variantId, quantity } }));
    window.dispatchEvent(new CustomEvent('cart:add_loading_end'));
    
    // Trigger minicart open event
    window.dispatchEvent(new CustomEvent('cart:open'));

    return {
      success: true,
      message: 'Item added to cart successfully'
    };
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    window.dispatchEvent(new CustomEvent('cart:add_loading_end'));
    window.dispatchEvent(new CustomEvent('arc:action:addToCartAndCartOpen:error', { detail: { error: error.message } }));
    return {
      success: false,
      error: error.message
    };
  }
};

export default runAddToCartAndCartOpen;
